import type { DrawingPresentationDto } from '@shared/types';
import { titleCase } from '@shared/format';
import { useNow } from '../kiosk';
import { Header } from './Header';

export function DrawingReadyScreen({ drawing }: { drawing: DrawingPresentationDto }) {
  const now = useNow(250);
  const scheduled = drawing.scheduledForUtc ? Date.parse(drawing.scheduledForUtc) : null;
  const remaining = scheduled ? Math.max(0, Math.ceil((scheduled - now) / 1000)) : null;
  const showCountdown = remaining !== null && remaining > 0 && remaining <= 3600;

  return (
    <div className="screen screen-ready">
      <Header compact />
      <div className="ready-card">
        <h2 className="ready-title">{titleCase(drawing.drawingType)} Drawing</h2>
        <div className="ready-period">{drawing.periodLabel}</div>
        {showCountdown ? (
          <>
            <div className="ready-sub">Starting in…</div>
            <div className="ring">
              <svg viewBox="0 0 200 200">
                <circle cx="100" cy="100" r="88" className="ring-bg" />
                <circle cx="100" cy="100" r="88" className="ring-fg" style={{ strokeDasharray: 553, strokeDashoffset: 553 * (1 - ((remaining! % 60) || 60) / 60) }} />
              </svg>
              <div className="ring-num tabular">{remaining! >= 60 ? `${Math.floor(remaining! / 60)}:${String(remaining! % 60).padStart(2, '0')}` : remaining}</div>
              <div className="ring-unit">{remaining! >= 60 ? 'minutes' : 'seconds'}</div>
            </div>
          </>
        ) : (
          <div className="ready-sub ready-pulse">Get ready — the wheel spins shortly</div>
        )}
        <div className="ready-entrants tabular">{drawing.entrantCount} Employees Entered</div>
        <div className="ready-prize">Prize: {drawing.prizeName}</div>
      </div>
    </div>
  );
}
